export default __webpack_public_path__ + "static/media/billards.0273d599.jpg";